// src/pages/onboarddeboard/employees/attendance/page.js

import React, { useState, useRef, useEffect } from "react";

// ─── Static Mock Data ─────────────────────────────────────────────────────────

const MOCK_RECORDS = [
  { id: 1,  employeeName: "Aarav Sharma",    empCode: "EMP001", department: "Engineering",  date: "2026-04-29", clockIn: "09:00", clockOut: "18:00", status: "Present"       },
  { id: 2,  employeeName: "Priya Mehta",     empCode: "EMP002", department: "Design",       date: "2026-04-29", clockIn: "09:15", clockOut: "18:30", status: "Present"       },
  { id: 3,  employeeName: "Rohit Verma",     empCode: "EMP003", department: "Engineering",  date: "2026-04-29", clockIn: "-",     clockOut: "-",     status: "Absent"        },
  { id: 4,  employeeName: "Sneha Patil",     empCode: "EMP004", department: "HR",           date: "2026-04-29", clockIn: "09:45", clockOut: "18:00", status: "Late"          },
  { id: 5,  employeeName: "Karan Joshi",     empCode: "EMP005", department: "Testing",      date: "2026-04-29", clockIn: "09:00", clockOut: "18:00", status: "Work From Home" },
  { id: 6,  employeeName: "Divya Nair",      empCode: "EMP006", department: "Engineering",  date: "2026-04-29", clockIn: "09:05", clockOut: "18:10", status: "Present"       },
  { id: 7,  employeeName: "Amit Kulkarni",   empCode: "EMP007", department: "Sales",        date: "2026-04-29", clockIn: "-",     clockOut: "-",     status: "On Leave"      },
  { id: 8,  employeeName: "Pooja Desai",     empCode: "EMP008", department: "Finance",      date: "2026-04-29", clockIn: "09:30", clockOut: "18:00", status: "Late"          },
  { id: 9,  employeeName: "Vikas Rao",       empCode: "EMP009", department: "Engineering",  date: "2026-04-29", clockIn: "09:00", clockOut: "18:00", status: "Present"       },
  { id: 10, employeeName: "Ananya Singh",    empCode: "EMP010", department: "Marketing",    date: "2026-04-29", clockIn: "09:00", clockOut: "18:00", status: "Work From Home" },
  { id: 11, employeeName: "Rahul Gupta",     empCode: "EMP011", department: "Engineering",  date: "2026-04-29", clockIn: "09:02", clockOut: "18:05", status: "Present"       },
  { id: 12, employeeName: "Meera Iyer",      empCode: "EMP012", department: "Design",       date: "2026-04-29", clockIn: "-",     clockOut: "-",     status: "Absent"        },
  { id: 13, employeeName: "Suresh Kumar",    empCode: "EMP013", department: "Testing",      date: "2026-04-29", clockIn: "09:10", clockOut: "18:15", status: "Present"       },
  { id: 14, employeeName: "Neha Bhatt",      empCode: "EMP014", department: "HR",           date: "2026-04-29", clockIn: "09:50", clockOut: "18:00", status: "Late"          },
  { id: 15, employeeName: "Ravi Patel",      empCode: "EMP015", department: "Finance",      date: "2026-04-29", clockIn: "-",     clockOut: "-",     status: "On Leave"      },
  { id: 16, employeeName: "Ishaan Malhotra", empCode: "EMP016", department: "Engineering",  date: "2026-04-29", clockIn: "09:00", clockOut: "18:00", status: "Present"       },
];

// ─── Constants ────────────────────────────────────────────────────────────────

const AVATAR_BG = "#dce8fb";
const AVATAR_FG = "#2563eb";

const STATUS_OPTIONS = ["All status", "Present", "Absent", "Late", "On Leave", "Work From Home"];

// ─── Helpers ──────────────────────────────────────────────────────────────────

const getInitials = (name) => {
  if (!name || !name.trim()) return null;
  return name.trim().split(/\s+/).filter(Boolean).map((w) => w[0].toUpperCase()).join("").slice(0, 2);
};

// ─── Sub-components ───────────────────────────────────────────────────────────

const Avatar = ({ name }) => {
  const initials = getInitials(name);
  return (
    <div style={{
      width: 36, height: 36, borderRadius: "50%", flexShrink: 0,
      background: AVATAR_BG,
      display: "flex", alignItems: "center", justifyContent: "center",
      fontSize: initials ? 13 : 16, fontWeight: 700, color: AVATAR_FG, userSelect: "none",
    }}>
      {initials || "—"}
    </div>
  );
};

const StatusBadge = ({ status }) => {
  const styles = {
    Present:          { background: "#dcfce7", color: "#16a34a" },
    Absent:           { background: "#fee2e2", color: "#dc2626" },
    Late:             { background: "#fef9c3", color: "#ca8a04" },
    "On Leave":       { background: "#ffedd5", color: "#ea580c" },
    "Work From Home": { background: "#ede9fe", color: "#7c3aed" },
  };
  const s = styles[status] || { background: "#f1f5f9", color: "#64748b" };
  return (
    <span style={{
      ...s, display: "inline-block", padding: "3px 12px",
      borderRadius: 20, fontSize: 12, fontWeight: 600, whiteSpace: "nowrap",
    }}>
      {status}
    </span>
  );
};

const StatCard = ({ value, label, borderColor }) => (
  <div style={{
    flex: 1, minWidth: 180, background: "#fff",
    border: "1px solid #e5e7eb", borderTop: `3px solid ${borderColor}`,
    borderRadius: 10, padding: "18px 22px", boxSizing: "border-box",
  }}>
    <div style={{ fontSize: 28, fontWeight: 700, color: "#111827", lineHeight: 1.2 }}>{value}</div>
    <div style={{ fontSize: 13, color: "#6b7280", marginTop: 5 }}>{label}</div>
  </div>
);

// ─── Main Component ───────────────────────────────────────────────────────────

const Attendance = () => {
  const [records]      = useState(MOCK_RECORDS);
  const [searchQuery,  setSearchQuery]  = useState("");
  const [statusFilter, setStatusFilter] = useState("All status");
  const [showDropdown, setShowDropdown] = useState(false);

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setShowDropdown(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  // ── Stat counts from static data ──
  const presentCount = records.filter((r) => r.status === "Present").length;
  const absentCount  = records.filter((r) => r.status === "Absent").length;
  const lateCount    = records.filter((r) => r.status === "Late").length;
  const wfhCount     = records.filter((r) => r.status === "Work From Home").length;

  // ── Filter by search + status ──
  const filtered = records.filter((r) => {
    const q = searchQuery.toLowerCase();
    const matchSearch =
      (r.employeeName || "").toLowerCase().includes(q) ||
      (r.empCode      || "").toLowerCase().includes(q) ||
      (r.department   || "").toLowerCase().includes(q);
    const matchStatus = statusFilter === "All status" || r.status === statusFilter;
    return matchSearch && matchStatus;
  });

  return (
    <div style={{
      padding: "24px 28px 40px",
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      background: "#f8fafc", minHeight: "calc(100vh - 60px)", boxSizing: "border-box",
    }}>

      {/* ── Header ── */}
      <div style={{ marginBottom: 24 }}>
        <h2 className="page-main-heading">Attendance</h2>
<p className="page-sub-heading">Track daily employee attendance</p>
      </div>

      {/* ── Stat Cards ── */}
      <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: 24 }}>
        <StatCard value={presentCount} label="Present Today"  borderColor="#22c55e" />
        <StatCard value={absentCount}  label="Absent Today"   borderColor="#ef4444" />
        <StatCard value={lateCount}    label="Late Arrivals"  borderColor="#f59e0b" />
        <StatCard value={wfhCount}     label="Work From Home" borderColor="#8b5cf6" />
      </div>

      {/* ── Search + Filter ── */}
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
        <div style={{ position: "relative", flex: 1 }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
            style={{ position: "absolute", left: 11, top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}>
            <circle cx="11" cy="11" r="7" stroke="#9ca3af" strokeWidth="2" />
            <path d="M16.5 16.5L21 21" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" />
          </svg>
          <input
            type="text"
            placeholder="Search employees..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{
              width: "100%", height: 36, padding: "0 12px 0 34px",
              border: "1px solid #e2e8f0", borderRadius: 8,
              fontSize: 13, color: "#374151", background: "#fff",
              outline: "none", boxSizing: "border-box", fontFamily: "inherit",
            }}
          />
        </div>

        <div style={{ position: "relative", flexShrink: 0 }} ref={dropdownRef}>
          <button
            onClick={() => setShowDropdown((v) => !v)}
            style={{
              display: "flex", alignItems: "center", gap: 10,
              height: 36, padding: "0 14px", border: "1px solid #e2e8f0",
              borderRadius: 8, background: "#fff", fontSize: 13, color: "#374151",
              cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap",
            }}
          >
            {statusFilter}
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
              <path d="M9 18l6-6-6-6" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>

          {showDropdown && (
            <div style={{
              position: "absolute", top: "calc(100% + 4px)", right: 0,
              background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8,
              boxShadow: "0 4px 16px rgba(0,0,0,0.10)", zIndex: 50,
              minWidth: 170, overflow: "hidden",
            }}>
              {STATUS_OPTIONS.map((opt) => (
                <div
                  key={opt}
                  onClick={() => { setStatusFilter(opt); setShowDropdown(false); }}
                  style={{
                    padding: "9px 14px", fontSize: 13, cursor: "pointer",
                    color: statusFilter === opt ? "#2563eb" : "#374151",
                    fontWeight: statusFilter === opt ? 600 : 400,
                    background: statusFilter === opt ? "#eff6ff" : "transparent",
                  }}
                  onMouseEnter={(e) => { if (statusFilter !== opt) e.currentTarget.style.background = "#f9fafb"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.background = statusFilter === opt ? "#eff6ff" : "transparent"; }}
                >
                  {opt}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* ── Table ── */}
      <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 10, overflow: "hidden" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "#f9fafb", borderBottom: "1px solid #e5e7eb" }}>
              {["Employee", "Department", "Date", "Clock In", "Clock Out", "Status"].map((col) => (
                <th key={col} style={{
                  padding: "12px 16px", textAlign: "left",
                  fontSize: 13, fontWeight: 600, color: "#374151", whiteSpace: "nowrap",
                }}>
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr>
                <td colSpan={6} style={{ padding: 40, textAlign: "center", color: "#9ca3af", fontSize: 13 }}>
                  No attendance records found.
                </td>
              </tr>
            ) : (
              filtered.map((r) => (
                <tr
                  key={r.id}
                  style={{ borderBottom: "1px solid #f1f5f9" }}
                  onMouseEnter={(e) => e.currentTarget.style.background = "#fafafa"}
                  onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
                >
                  <td style={{ padding: "12px 16px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <Avatar name={r.employeeName} />
                      <div>
                        <div style={{ fontSize: 13, fontWeight: 600, color: "#111827" }}>{r.employeeName || "—"}</div>
                        <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 1 }}>{r.empCode || "—"}</div>
                      </div>
                    </div>
                  </td>
                  <td style={{ padding: "12px 16px", fontSize: 13, color: "#374151" }}>{r.department || "—"}</td>
                  <td style={{ padding: "12px 16px", fontSize: 13, color: "#374151" }}>{r.date || "—"}</td>
                  <td style={{ padding: "12px 16px", fontSize: 13, color: "#374151" }}>{r.clockIn || "-"}</td>
                  <td style={{ padding: "12px 16px", fontSize: 13, color: "#374151" }}>{r.clockOut || "-"}</td>
                  <td style={{ padding: "12px 16px" }}><StatusBadge status={r.status} /></td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Attendance;